var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row margin-bottom" },
      [
        _c(
          "b-col",
          { attrs: { sm: "12", md: "6" } },
          [
            _c(
              "b-form-group",
              {
                staticClass: "mb-0",
                attrs: {
                  "label-cols-sm": "12",
                  "label-cols-md": "6",
                  "label-cols-lg": "2",
                  "label-align-md": "right"
                }
              },
              [
                _c("label", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Käyttöpaikan osoite")))
                ]),
                _vm._v(" " + _vm._s(_vm.addressString))
              ]
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "mb-0",
                attrs: {
                  "label-cols-sm": "12",
                  "label-cols-md": "6",
                  "label-cols-lg": "2",
                  "label-align-md": "right"
                }
              },
              [
                _c("label", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Käyttöpaikkatunnus")))
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.meteringPoint.GsrnCode))])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-col",
          { attrs: { sm: "12", md: "6" } },
          [
            _c(
              "b-form-group",
              {
                staticClass: "mb-0",
                attrs: {
                  "label-cols-sm": "12",
                  "label-cols-md": "8",
                  "label-cols-lg": "2",
                  "label-align-md": "right"
                }
              },
              [
                _c("label", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Toivottu alkupäivä")))
                ]),
                _vm._v(" " + _vm._s(_vm._f("date")(_vm.contract.StartDate)))
              ]
            ),
            _vm._v(" "),
            _vm.isInvoicingMethodsInUse
              ? _c(
                  "b-form-group",
                  {
                    staticClass: "mb-0",
                    attrs: {
                      "label-cols-sm": "12",
                      "label-cols-md": "8",
                      "label-cols-lg": "2",
                      "label-align-md": "right"
                    }
                  },
                  [
                    _c("label", { staticClass: "font-weight-bold pt-0" }, [
                      _vm._v(_vm._s(_vm.$t("Laskutustapa")))
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.invoicingTypeString(_vm.contract.InvoicingMethod)
                        )
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isInvoicingMethodsInUse &&
            _vm.contract.InvoicingMethod == _vm.InvoicingMethodEnum.Paper
              ? _c(
                  "b-form-group",
                  {
                    staticClass: "mb-0",
                    attrs: {
                      "label-cols-sm": "12",
                      "label-cols-md": "8",
                      "label-cols-lg": "2",
                      "label-align-md": "right"
                    }
                  },
                  [
                    _c("label", { staticClass: "font-weight-bold pt-0" }, [
                      _vm._v(_vm._s(_vm.$t("Laskutusosoite")))
                    ]),
                    _c("br"),
                    _vm.contract.InvoicingAddress.Address.COName
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              " " + _vm.contract.InvoicingAddress.Address.COName
                            )
                          ),
                          _c("br")
                        ])
                      : _vm._e(),
                    _vm._v(
                      _vm._s(_vm.contract.InvoicingAddress.Address.Street)
                    ),
                    _c("br"),
                    _vm._v(
                      _vm._s(
                        _vm.formatPostal(
                          _vm.contract.InvoicingAddress.Address.Zip,
                          _vm.contract.InvoicingAddress.Address.Place
                        )
                      )
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isInvoicingMethodsInUse &&
            _vm.contract.InvoicingMethod == _vm.InvoicingMethodEnum.Email
              ? _c(
                  "b-form-group",
                  {
                    staticClass: "mb-0",
                    attrs: {
                      "label-cols-sm": "12",
                      "label-cols-md": "8",
                      "label-cols-lg": "2",
                      "label-align-md": "right"
                    }
                  },
                  [
                    _c("label", { staticClass: "font-weight-bold pt-0" }, [
                      _vm._v(_vm._s(_vm.$t("Sähköpostiosoite")))
                    ]),
                    _vm._v(" " + _vm._s(_vm.contract.DeliveryEmail))
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isInvoicingMethodsInUse &&
            _vm.contract.InvoicingMethod ==
              _vm.InvoicingMethodEnum.CompanyEInvoice
              ? _c(
                  "b-form-group",
                  {
                    staticClass: "mb-0",
                    attrs: {
                      "label-cols-sm": "12",
                      "label-cols-md": "8",
                      "label-cols-lg": "2",
                      "label-align-md": "right"
                    }
                  },
                  [
                    _c("label", { staticClass: "font-weight-bold pt-0" }, [
                      _vm._v(_vm._s(_vm.$t("Verkkolaskuosoite (OVT-tunnus)")))
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.contract.InvoicingAddress.InvoicingNetworkAddress
                        )
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isInvoicingMethodsInUse &&
            _vm.contract.InvoicingMethod ==
              _vm.InvoicingMethodEnum.CompanyEInvoice
              ? _c(
                  "b-form-group",
                  {
                    staticClass: "mb-0",
                    attrs: {
                      "label-cols-sm": "12",
                      "label-cols-md": "8",
                      "label-cols-lg": "2",
                      "label-align-md": "right"
                    }
                  },
                  [
                    _c("label", { staticClass: "font-weight-bold pt-0" }, [
                      _vm._v(_vm._s(_vm.$t("Välittäjätunnus")))
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.contract.InvoicingAddress.InvoicingOperator)
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }